import React, {useState} from 'react'
import VisDiv from '../frontend_components/VisDiv'
import { useStateContext } from '../../context/StateContext'
import PrivacyPolicy from '../PrivacyPolicy'
import { useSetOnlyPassedData } from '../../hooks/mutations'

/**
 * AcceptPrivacyPolicy is a React component that displays a privacy policy and allows the user to accept it.
 * When the user accepts the privacy policy, the component updates the user document with the acceptedPrivacyPolicy flag set to true.
 * If the update fails, the component displays an error message.
 * #login 
 * @returns {React.ReactElement} - a React element representing the AcceptPrivacyPolicy component
 * 
 */
const AcceptPrivacyPolicy = () => {

    const { sUser, setSUser, customer } = useStateContext()  
    const {mutate: updateUser} = useSetOnlyPassedData({
        onSuccess: (data) => {
            //console.log("User Updated Successfully", data);
            const updatedSUserDoc = {...sUser, acceptedPrivacyPolicy: true}
            setSUser(updatedSUserDoc)
            },

        onError: (err, newDoc, context) => {
            //console.error('Oh no, the update failed: ', err?.message)
            errorAlert("ERRORE; Il documento non è stato modificato Ricarica la pagina")
        }
        })
    const queryDoc = {
        documentId: sUser?._id,
        doc: {acceptedPrivacyPolicy: true}
    }
    return (
        <div className="products-heading" style={{textAlign: "left", backgroundColor:"white", height:"90vh"}}>
            <div  style={{backgroundColor:"#D3D3D3", borderRadius:"10px", height:"85vh", margin:"10px", padding:"20px", textAlign: "left"}}>
                <VisDiv style={{overflow:"auto", height:"90%"}} rules={[true]}>
                    <PrivacyPolicy customer={customer} />
                </VisDiv>
                <VisDiv rules={[true]}>
                    <div className="pdf-button" style={{cursor:"pointer", marginTop:"20px", textAlign:"center", backgroundColor:"green", color:"white", padding:"10px", borderRadius:"10px"}} onClick={() => updateUser(queryDoc)} >
                        ACCETTA LA NOSTRA POLITICA PRIVACY
                    </div>
                </VisDiv>
            </div>
        </div>
    )
}

export default AcceptPrivacyPolicy
